import React, {useEffect} from 'react';
import { ReactComponent as GroupIcon } from '../../../assets/main/groups/main-top/group.svg';
import { MainTop } from './group-container/main-top/Main-top';
import { GroupTable } from 'components/pages/groups/group-table/GroupTable';
import {useAppDispatch, useAppSelector} from "common/hook";
import AuthWrapper from "../../auth-wrapper/AuthWrapper";
import { fetchGroups } from "features/model/service/groups/fetchGroups";
import { ROLE_HR } from "entities/constants/constants";
import { ShowEndedGroupsCheckbox } from "components/pages/hr/show-ended-groups-checkbox/ShowEndedGroupsCheckbox";
import { setGroupsFilters } from "features/model/slice/groups/groupsSlice";

export const Groups = () => {
    const dispatch = useAppDispatch();
    const roleType = useAppSelector((state) => state.role.roleType);
    const includeEnded = useAppSelector((state) => state.groups.filters.includeEnded);

    useEffect(() => {
        dispatch(fetchGroups({page: 0, includeEnded}));
    }, [dispatch, includeEnded]);

    const onIncludeEndedChange = (checked: boolean) => {
        dispatch(setGroupsFilters({includeEnded: checked}));
    };

    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop title={'Группы'} tabs={false} setting={false} link={'/groups'} icons={<GroupIcon />}/>
                {roleType === ROLE_HR && (
                    <div className="tabs-content">
                        <div className="tab">
                            <div className="data-tbl-controls controls_data-tbl hr-groups-controls">
                                <div className="controls_data-tbl-block">
                                    <ShowEndedGroupsCheckbox
                                        checked={includeEnded}
                                        onChange={onIncludeEndedChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <GroupTable />
            </div>
        </AuthWrapper>
    );
};
